/**
 * Filter presets for media assets. Stored as a spec ({ preset, ...params }) in
 * media_assets.filter and replayed on the client purely through CSS `filter:`.
 * No server-side baking (Telegram file is immutable) — the spec → CSS string
 * here is the single source of truth shared by the cabinet preview and (later)
 * the client dossier renderer.
 *
 * Default is «Архив» — the baked-in archival look (grayscale + sepia + contrast
 * lift) used across the client досье. Two more presets give variety.
 */
export interface FilterPreset {
  id: string;
  name: string;
  /** CSS `filter` value. */
  css: string;
}

export const FILTER_PRESETS: FilterPreset[] = [
  { id: "archive", name: "Архив", css: "grayscale(0.55) sepia(0.35) contrast(1.12) brightness(0.95) saturate(0.8)" },
  { id: "none", name: "Без", css: "none" },
  { id: "noir", name: "Нуар", css: "grayscale(1) contrast(1.25) brightness(0.9)" },
  { id: "warm", name: "Тёплый", css: "sepia(0.5) saturate(1.2) contrast(1.05) brightness(1.02)" },
];

/** Default preset id applied to a freshly-uploaded asset. */
export const DEFAULT_PRESET = "archive";

/** Resolve a stored filter spec to a CSS `filter` string. */
export function filterToCss(filter: Record<string, unknown> | undefined): string {
  const id = (filter?.preset as string | undefined) ?? DEFAULT_PRESET;
  const preset = FILTER_PRESETS.find((p) => p.id === id) ?? FILTER_PRESETS[0]!;
  return preset.css;
}

/** Current preset id from a stored spec (defaults to archive). */
export function currentPreset(filter: Record<string, unknown> | undefined): string {
  return (filter?.preset as string | undefined) ?? DEFAULT_PRESET;
}
